<div class="sign-up-page min-h-50 text-white">
    <div class="slider-bg-img gradient01 ">
        <div class="container">
            <nav class="py-4">
                <ol itemscope itemtype="http://schema.org/BreadcrumbList" class="breadcrumb breadcrumb-arrow breadcrumb-tdm mb-0">
                  <li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem" class="breadcrumb-item fw-semibold"><meta itemprop="position" content="1">
                    <a itemprop="item" [routerLink]="['/accueil']" role="button" routerLinkActive="router-link-active"><span itemprop="name">Accueil</span></a></li>
                  <li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem" class="breadcrumb-item active" aria-current="page"><meta itemprop="position" content="2"><span itemprop="name">Création compte</span></li>
                </ol>
            </nav>
            <div class="row row-cols-md-1 row-cols-sm-1 ">
                <div class="slider-txt py-md-5 py-sm-2">
                    <div class="h-100">
                        <h1 class="heading text-uppercase">
                            Créer <span style="color : #BADFFF"> un compte ?
                            </span>
                        </h1>
                    </div>
                    <div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="sign-up-bloc py-5">
        <div class="bloc-sign-up container">
            <div class="bg-white shadow rounded">
                <div class="row">
                    <div class="col-md-7 ">
                        <div class="form-left h-100 py-5 px-5">
                            <form #loginForm="ngForm" class="row g-4">
                                <div class="col-12">
                                    <div class="alert alert-danger" [hidden]="!showError" [innerHTML]="errorMessage">
                                    </div>
                                </div>
                                <div class="col-12 text-center">
                                    <h4>JE SUIS</h4>
                                    <div>
                                        <button routerLinkActive="router-link-active" type="submit"
                                            class="btn btn-outline-primary  px-4 float-center mt-4 mx-2">
                                            Un Particulier</button>
                                        <button routerLinkActive="router-link-active" type="submit"
                                            class="btn btn-outline-primary  px-4 float-center mt-4 mx-2">
                                            Un Professionnel</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="col-md-5 ">
                        <div class="form-right h-100 bg-primary text-white text-start p-5">
                            En créant votre compte <span class="blue-text"><strong>THE DOOR MAN</strong></span>, vous
                            bénéficiez de nombreux services :
                            <div class="clearfix float-content mt-2">
                                <ul>
                                    <li>Informations sauvegardées</li>
                                    <li>Réception des offres par mail</li>
                                    <li>Prise de rendez-vous pour un bien</li>
                                    <li>Enregistrement de vos recherches</li>
                                    <li>Enregistrement de vos biens favoris</li>
                                    <li>Abonnement à la newsletter</li>
                                    <li>Suivi personnalisé</li>
                                </ul>

                                <button [routerLink]="['/connexion']" routerLinkActive="router-link-active"
                                    type="submit" class="btn btn-secondary  px-4 float-end mt-4 mx-2">
                                    Se connecter</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
